import { FFContextProvider } from '@harnessio/ff-react-client-sdk';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import NoInternetConnection from './components/common/NoInternetConnection';
import settings from './constants/constants';
import Routes from './routes/routes';

function App() {

  const [width, setWindowWidth] = React.useState(0);

  React.useEffect(() => { 
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const updateDimensions = () => {
    const windowWidth = window.innerWidth;
    setWindowWidth(windowWidth);
  };

  return (
   
    <React.Fragment>
      <NoInternetConnection>
        <ToastContainer
          position="top-right"
          autoClose={7500}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          pauseOnHover
        />
        <FFContextProvider
          apiKey={settings.FeatureFlagSDKKey}
          target={{
            identifier: 'montu-leafio-frontend',
            name: 'Montu Leafio Frontend'
          }}
          async
        > 
          <Routes screenWidth={width} />
        </FFContextProvider>
      </NoInternetConnection>
    </React.Fragment>
   
  );
}

export default App;
